import React from 'react';

import {ContinueShoppingButton} from '../continueShoppingButton/continueShoppingButton';

import s from '../successMessageWithoutDash.scss';

/**
 * Success screen on contact lenses
 * @returns {React.ReactNode} react template
 */
export const WeWillVerifyPrescription = React.memo(() => (
    <div className={s.wrapper}>
        <p className={s.description}>
            We will verify the prescription with your eye doctor.
            <br /> This may take up to 1 business day.
        </p>
        <ContinueShoppingButton />
    </div>
));

WeWillVerifyPrescription.displayName = 'WeWillVerifyPrescription';
